import z from 'zod';

import type { QcsResourceSlice } from '../core/resourceSliceUtils';
import { InvoiceItemSchema } from '../invoice-items/invoiceItemTypes';
export const BILLABLE_INVOICE_ITEMS_REDUCER_KEY = 'billableInvoiceItemsStore';
export type BILLABLE_INVOICE_ITEMS_REDUCER_KEY = typeof BILLABLE_INVOICE_ITEMS_REDUCER_KEY;

// https://bitbucket.org/quicken/qcs-fmcore-dtos/src/master/src/main/java/com/quicken/fmcore/dtos/BillableItemResource.java
export const BillableInvoiceItemSchema = InvoiceItemSchema.and(
  z
    .object({
      projectId: z.string(),
      itemId: z.string(),
      status: z.enum(['UNBILLED', 'BILLED', 'PAID', 'NON_BILLABLE', 'UNKNOWN']).catch('UNKNOWN'),
      serviceDateOn: z.string(),
    })
    .partial(),
).and(
  z.object({
    // customer id is required for billable invoice items
    customerId: z.string(),
  }),
);

export type BillableInvoiceItemType = z.infer<typeof BillableInvoiceItemSchema>;

export type BillableInvoiceItemsState = QcsResourceSlice<BillableInvoiceItemType>;

declare module 'app-components/utils/redux-store/rootState' {
  export default interface RootState {
    [BILLABLE_INVOICE_ITEMS_REDUCER_KEY]: BillableInvoiceItemsState;
  }
}
